module.exports = __webpack_public_path__ + "menu_1_active_pc.a635d20d.png";